{
  "CONTACT_PANEL": {
    "CONFIRM": {
      "YES": "OK",
      "CANCEL": "Otkaži"
    },
    "NOT_AVAILABLE": "Nije dostupno",
    "EMAIL_ADDRESS": "E-mail adresa",
    "PHONE_NUMBER": "Broj telefona",
    "WHATSAPP_USERNAME": "WhatsApp korisničko ime",
    "IDENTIFIER": "Identifikator",
    "COPY_SUCCESSFUL": "Uspešno kopirano na beležnicu",
    "COPY_NAME": "Kopiraj ime",
    "COPY_REFERER": "Kopiraj URL",
    "COMPANY": "Firma",
    "LOCATION": "Lokacija",
    "LTV": "LTV",
    "BROWSER_LANGUAGE": "Jezik pregledača",
    "CONVERSATION_LANGUAGE": "Jezik razgovora",
    "CONVERSATION_TITLE": "Detalji razgovora",
    "VIEW_PROFILE": "Pogledaj profil",
    "BROWSER": "Pretraživač",
    "OS": "Operativni sistem",
    "INITIATED_FROM": "Započeto sa",
    "INITIATED_AT": "Započeto u",
    "IP_ADDRESS": "IP adresa",
    "CREATED_AT_LABEL": "Kreirano",
    "NEW_MESSAGE": "Nova poruka",
    "CONVERSATIONS": {
      "NO_RECORDS_FOUND": "Nema ranijih razgovora povezanih sa ovim kontaktom.",
      "TITLE": "Prethodni razgovor"
    },
    "LABELS": {
      "CONTACT": {
        "TITLE": "Oznake kontakta",
        "ERROR": "Nije bilo moguće izmeniti oznake"
      },
      "CONVERSATION": {
        "TITLE": "Oznake razgovora",
        "ADD_BUTTON": "Dodaj oznake"
      },
      "LABEL_SELECT": {
        "TITLE": "Dodaj oznake",
        "PLACEHOLDER": "Pretraži oznake",
        "NO_RESULT": "Oznake nisu pronađene",
        "CREATE_LABEL": "Create new label"
      }
    },
    "MERGE_CONTACT": "Spoji kontakt",
    "CONTACT_ACTIONS": "Akcije nad kontaktom",
    "MUTE_CONTACT": "Block Contact",
    "MUTE_CONTACT_DISABLED": "Ne može se koristiti. Ceo domen kontakta je blokiran.",
    "UNMUTE_CONTACT": "Unblock Contact",
    "BLOCK_CONTACT_DOMAIN": "Blokiraj domen kontakta",
    "UNBLOCK_CONTACT_DOMAIN": "Odblokiraj domen kontakta",
    "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blokiranjem domena blokiraćete sve postojeće i buduće kontakte za taj domen.",
    "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Odblokiranjem domena uklonićete blokadu za sve kontakte tog domena (uključujući one koji su ručno blokirani).",
    "MUTED_SUCCESS": "Овај контакт је успешно блокиран. Његови разговори ће ускоро бити решени у позадини.",
    "UNMUTED_SUCCESS": "This contact is unblocked successfully.",
    "OPEN_JARABOT": "Otvori istoriju AI odgovora",
    "TRANSLATE_CONVERSATION": "Prevedi razgovor",
    "TRANSLATE_INITIATED": "Prevođenje je započeto. Ovo može potrajati kod dužih razgovora.",
    "TRANSLATE_SUCCESS": "Prevođenje razgovora je uspešno završeno.",
    "TRANSLATE_ERROR": "Nije uspelo prevođenje razgovora. Pokušajte ponovo.",
    "MOVE_CONVERSATION": "Premesti razgovor",
    "MOVE_CONVERSATION_MISSING_EMAIL": "E-pošta kontakta je obavezna za premeštanje razgovora u sanduče e-pošte",
    "MERGE_CONVERSATION": "Spoji razgovor",
    "CONTACT_DOMAIN_BLOCKED_SUCCESS": "Ovaj domen je uspešno blokiran. Nećete dobijati obaveštenja o budućim razgovorima.",
    "CONTACT_DOMAIN_UNBLOCKED_SUCCESS": "Ovaj domen je uspešno odblokiran.",
    "SEND_TRANSCRIPT": "Pošalji transkript",
    "EDIT_LABEL": "Uredi",
    "SIDEBAR_SECTIONS": {
      "CUSTOM_ATTRIBUTES": "Prilagođeni atributi",
      "CONTACT_LABELS": "Oznake kontakta",
      "PREVIOUS_CONVERSATIONS": "Prethodni razgovor",
      "NO_RECORDS_FOUND": "Nijedan atribut nije pronađen"
    },
    "BLOCK_PUBLIC_DOMAIN_TITLE": "Јавни домен е-поште",
    "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} је јавни домен е-поште који користи много неповезаних пошиљалаца, па се не може блокирати у целини. Да ли желите да блокирате само ову адресу ({email})?",
    "BLOCK_ONLY_THIS_ADDRESS": "Блокирај само ову адресу"
  },
  "EDIT_CONTACT": {
    "BUTTON_LABEL": "Uredi kontakt",
    "TITLE": "Uredi kontakta",
    "DESC": "Uredi detalje kontakta"
  },
  "DELETE_CONTACT": {
    "BUTTON_LABEL": "Obriši kontakt",
    "TITLE": "Obriši kontakt",
    "DESC": "Obriši detalje o kontaktu",
    "CONFIRM": {
      "TITLE": "Potvrdite brisanje",
      "MESSAGE": "Sigurni ste da želite izbrisati ",
      "YES": "Da, izbriši",
      "NO": "Ne, zadrži"
    },
    "API": {
      "SUCCESS_MESSAGE": "Kontakt je uspešno obrisan",
      "ERROR_MESSAGE": "Nije bilo moguće obrisati kontakt. Molim vas pokušajte ponovo."
    }
  },
  "CONTACT_FORM": {
    "FORM": {
      "SUBMIT": "Сачувај",
      "CANCEL": "Otkaži",
      "AVATAR": {
        "LABEL": "Avatar kontakta"
      },
      "NAME": {
        "PLACEHOLDER": "Unesite puno ime kontakta",
        "LABEL": "Puno ime"
      },
      "BIO": {
        "PLACEHOLDER": "Unesite biografiju kontakta",
        "LABEL": "Bio"
      },
      "EMAIL_ADDRESS": {
        "PLACEHOLDER": "Unesite adresu e-pošte kontakta",
        "LABEL": "E-mail adresa",
        "DUPLICATE": "Ova adresa e-pošte je iskorišćena kod drugog kontakta.",
        "ERROR": "Molim vas unesite ispravnu adresu e-pošte."
      },
      "PHONE_NUMBER": {
        "PLACEHOLDER": "Unesite broj telefona kontakta",
        "LABEL": "Broj telefona",
        "HELP": "Phone number should be of E.164 format eg: +1415555555 [+][country code][area code][local phone number]. You can select the dial code from the dropdown.",
        "ERROR": "Broj telefona bi trebao biti ili prazan ili u E.164 formatu",
        "DIAL_CODE_ERROR": "Please select a dial code from the list",
        "DUPLICATE": "Broj telefona je iskorišćen kod drugog kontakta."
      },
      "LOCATION": {
        "PLACEHOLDER": "Unesite lokaciju kontakta",
        "LABEL": "Lokacija"
      },
      "COMPANY_NAME": {
        "PLACEHOLDER": "Unesite ime kompanije",
        "LABEL": "Ime firme"
      },
      "COUNTRY": {
        "PLACEHOLDER": "Enter the country name",
        "LABEL": "Naziv zemlje",
        "SELECT_PLACEHOLDER": "Select",
        "REMOVE": "Ukloni",
        "SELECT_COUNTRY": "Select Country"
      },
      "CITY": {
        "PLACEHOLDER": "Enter the city name",
        "LABEL": "City Name"
      },
      "SOCIAL_PROFILES": {
        "FACEBOOK": {
          "PLACEHOLDER": "Unesite Fejsbuk korisničko ime",
          "LABEL": "Facebook"
        },
        "TWITTER": {
          "PLACEHOLDER": "Unesite Tviter korisničko ime",
          "LABEL": "Twitter"
        },
        "LINKEDIN": {
          "PLACEHOLDER": "Unesite LinkedIn korisničko ime",
          "LABEL": "LinkedIn"
        },
        "GITHUB": {
          "PLACEHOLDER": "Unesite Github korisničko ime",
          "LABEL": "Github"
        }
      },
      "UNSAVED_CHANGES": {
        "TITLE": "Несачуване измене",
        "DESCRIPTION": "Имате несачуване измене. Да ли желите да их сачувате пре затварања?",
        "CONFIRM": "Сачувај",
        "CANCEL": "Одбаци"
      }
    },
    "DELETE_AVATAR": {
      "API": {
        "SUCCESS_MESSAGE": "Avatar kontakta je uspešno obrisan",
        "ERROR_MESSAGE": "Nije bilo moguće obrisati avatar kontakta. Molim vas pokušajte ponovo."
      }
    },
    "SUCCESS_MESSAGE": "Kontakt je uspešno sačuvan",
    "ERROR_MESSAGE": "Pojavila se greška, molim vas pokušajte ponovo"
  },
  "NEW_CONVERSATION": {
    "BUTTON_LABEL": "Započnite razgovor",
    "TITLE": "Novi razgovor",
    "DESC": "Započnite novi razgovor slanjem poruke.",
    "NO_INBOX": "Nije bilo moguće pronaći prijemno sanduče da bi se započeo novi razgovor sa ovim kontaktom.",
    "FORM": {
      "TO": {
        "LABEL": "Za"
      },
      "INBOX": {
        "LABEL": "Via Inbox",
        "PLACEHOLDER": "Choose source inbox",
        "ERROR": "Izaberite prijemno sanduče"
      },
      "SUBJECT": {
        "LABEL": "Naslov",
        "PLACEHOLDER": "Naslov",
        "ERROR": "Naslov ne može biti prazan"
      },
      "MESSAGE": {
        "LABEL": "Poruka",
        "PLACEHOLDER": "Unesite Vašu poruku ovde",
        "ERROR": "Poruka ne može biti prazna"
      },
      "ATTACHMENTS": {
        "SELECT": "Izaberite datoteke",
        "HELP_TEXT": "Prevucite i pustite ovde datoteke ili izaberite datoteke koje želite da priložite"
      },
      "SUBMIT": "Pošalji poruku",
      "CANCEL": "Otkaži",
      "SUCCESS_MESSAGE": "Poruka je poslata!",
      "GO_TO_CONVERSATION": "Pogledaj",
      "ERROR_MESSAGE": "Slanje neuspešno, pokušajte ponovo"
    }
  },
  "CONTACTS_PAGE": {
    "LIST": {
      "TABLE_HEADER": {
        "SOCIAL_PROFILES": "Socijalne mreže"
      }
    }
  },
  "CUSTOM_ATTRIBUTES": {
    "BUTTON": "Dodaj vlastite atribute",
    "COPY_SUCCESSFUL": "Uspešno kopirano na beležnicu",
    "SHOW_MORE": "Show all attributes",
    "SHOW_LESS": "Show less attributes",
    "ACTIONS": {
      "COPY": "Kopiraj atribut",
      "DELETE": "Obriši atribut",
      "EDIT": "Uredi atribut"
    },
    "ADD": {
      "TITLE": "Napravi prilagođeni atribut",
      "DESC": "Dodaj prilagođenu informaciju ovom kontaktu."
    },
    "FORM": {
      "CREATE": "Dodaj atribut",
      "CANCEL": "Otkaži",
      "NAME": {
        "LABEL": "Naziv prilagođenog atributa",
        "PLACEHOLDER": "Npr.: shopify id",
        "ERROR": "Neispravan naziv prilagođenog atributa"
      },
      "VALUE": {
        "LABEL": "Vrednost atributa",
        "PLACEHOLDER": "Npr.: 11901 "
      },
      "ADD": {
        "TITLE": "Napravi novi atribut ",
        "SUCCESS": "Atribut je uspešno dodat",
        "ERROR": "Nije bilo moguće dodati atribut. Molim vas pokušajte ponovo"
      },
      "UPDATE": {
        "SUCCESS": "Atribut je uspešno izmenjen",
        "ERROR": "Nije bilo moguće izmeniti atribut. Molim vas pokušajte ponovo"
      },
      "DELETE": {
        "SUCCESS": "Atribut je uspešno obrisan",
        "ERROR": "Nije bilo moguće obrisati atribut. Molim vas pokušajte ponovo"
      },
      "ATTRIBUTE_SELECT": {
        "TITLE": "Dodaj atribute",
        "PLACEHOLDER": "Traži atribute",
        "NO_RESULT": "Nijedan atribut nije pronađen"
      },
      "ATTRIBUTE_TYPE": {
        "LIST": {
          "PLACEHOLDER": "Izaberite vrednost",
          "SEARCH_INPUT_PLACEHOLDER": "Pretražite vrednost",
          "NO_RESULT": "Nema rezultata"
        }
      }
    },
    "VALIDATIONS": {
      "REQUIRED": "Ispravna vrednost je obavezna",
      "INVALID_URL": "Neispravna adresa",
      "INVALID_INPUT": "Invalid Input"
    }
  },
  "MERGE_CONTACTS": {
    "TITLE": "Spajanje kontakata",
    "DESCRIPTION": "Spojite kontakte da bi ste spojili dva profila u jedan, uključujući sve atribute i razgovore. U slučaju neslaganja, atributi primarnog kontakta će imati prednost.",
    "PRIMARY": {
      "TITLE": "Glavni kontakt",
      "HELP_LABEL": "Da bude obrisan"
    },
    "PARENT": {
      "TITLE": "Kontakt za spajanje",
      "PLACEHOLDER": "Traži kontakta",
      "HELP_LABEL": "Da bude zadržan"
    },
    "SUMMARY": {
      "TITLE": "Rezime",
      "DELETE_WARNING": "Kontakt <strong>{primaryContactName}</strong> će biti obrisan.",
      "ATTRIBUTE_WARNING": "Detalji kontakta <strong>{primaryContactName}</strong> će biti iskopirani u <strong>{parentContactName}</strong>."
    },
    "SEARCH": {
      "ERROR_MESSAGE": "Something went wrong. Please try again later."
    },
    "FORM": {
      "SUBMIT": " Spajanje kontakata",
      "CANCEL": "Otkaži",
      "CHILD_CONTACT": {
        "ERROR": "Izaberite dete kontakt za spajanje"
      },
      "SUCCESS_MESSAGE": "Kontakt je uspešno spojen",
      "ERROR_MESSAGE": "Nije bilo moguće spojiti kontakte, pokušajte ponovo!"
    },
    "DROPDOWN_ITEM": {
      "ID": "(ID: {identifier})"
    }
  },
  "CONTACTS_LAYOUT": {
    "HEADER": {
      "TITLE": "Kontakti",
      "SEARCH_TITLE": "Search contacts",
      "SEARCH_PLACEHOLDER": "Search...",
      "MESSAGE_BUTTON": "Poruka",
      "SEND_MESSAGE": "Pošalji poruku",
      "SHOW_DETAILS": "Detalji kontakta",
      "BLOCKING": "Blokiranje",
      "BLOCK_CONTACT": "Block contact",
      "UNBLOCK_CONTACT": "Unblock contact",
      "BLOCK_CONTACT_MESSAGE": "Blokiranjem ovog kontakta sprečićete ga da pokreće nove razgovore, a svi njegovi postojeći razgovori biće rešeni. Da li ste sigurni da želite da blokirate ovaj kontakt?",
      "UNBLOCK_CONTACT_MESSAGE": "Odblokiranjem ovog kontakta omogućićete mu da pokreće nove razgovore. Da li ste sigurni da želite da odblokirate ovaj kontakt?",
      "BLOCK_CONTACT_DOMAIN": "Blokiraj domen kontakta",
      "UNBLOCK_CONTACT_DOMAIN": "Odblokiraj domen kontakta",
      "BLOCK_CONTACT_DOMAIN_MESSAGE": "Blokiranjem domena blokiraćete sve postojeće i buduće kontakte za taj domen.",
      "UNBLOCK_CONTACT_DOMAIN_MESSAGE": "Odblokiranjem domena uklonićete blokadu za sve kontakte tog domena (uključujući one koji su ručno blokirani).",
      "BREADCRUMB": {
        "CONTACTS": "Kontakti"
      },
      "ACTIONS": {
        "CONTACT_CREATION": {
          "ADD_CONTACT": "Add contact",
          "EXPORT_CONTACT": "Export contacts",
          "IMPORT_CONTACT": "Import contacts",
          "SAVE_CONTACT": "Save contact",
          "EMAIL_ADDRESS_DUPLICATE": "Ova adresa e-pošte je iskorišćena kod drugog kontakta.",
          "PHONE_NUMBER_DUPLICATE": "Broj telefona je iskorišćen kod drugog kontakta.",
          "SUCCESS_MESSAGE": "Kontakt je uspešno sačuvan",
          "ERROR_MESSAGE": "Unable to save contact. Please try again later."
        },
        "BLOCK_SUCCESS_MESSAGE": "Овај контакт је успешно блокиран. Његови разговори ће ускоро бити решени у позадини.",
        "BLOCK_ERROR_MESSAGE": "Unable to block contact. Please try again later.",
        "UNBLOCK_SUCCESS_MESSAGE": "This contact is unblocked successfully",
        "UNBLOCK_ERROR_MESSAGE": "Unable to unblock contact. Please try again later.",
        "IMPORT_CONTACT": {
          "TITLE": "Import contacts",
          "DESCRIPTION": "Uvezi kontakte uz pomoć CSV datoteke.",
          "DOWNLOAD_LABEL": "Preuzmi csv primer.",
          "LABEL": "CSV datoteka:",
          "CHOOSE_FILE": "Choose file",
          "CHANGE": "Promeni",
          "CANCEL": "Otkaži",
          "IMPORT": "Uvoz",
          "SUCCESS_MESSAGE": "Bićete obavešteni putem e-poruke kada se uvoz završi.",
          "ERROR_MESSAGE": "Pojavila se greška, molim vas pokušajte ponovo"
        },
        "EXPORT_CONTACT": {
          "TITLE": "Export contacts",
          "DESCRIPTION": "Quickly export a csv file with comprehensive details of your contacts",
          "CONFIRM": "Export",
          "SUCCESS_MESSAGE": "Export is in progress, You will be notified via email when export file is ready to dowanlod.",
          "ERROR_MESSAGE": "Pojavila se greška, molim vas pokušajte ponovo"
        },
        "SORT_BY": {
          "LABEL": "Sortirajte prema",
          "OPTIONS": {
            "NAME": "Ime",
            "EMAIL": "E-pošta",
            "PHONE_NUMBER": "Broj telefona",
            "COMPANY": "Firma",
            "COUNTRY": "Država",
            "CITY": "Grad",
            "LAST_ACTIVITY": "Poslednja aktivnost",
            "CREATED_AT": "Napravljena u"
          }
        },
        "ORDER": {
          "LABEL": "Ordering",
          "OPTIONS": {
            "ASCENDING": "Ascending",
            "DESCENDING": "Descending"
          }
        },
        "FILTERS": {
          "CREATE_SEGMENT": {
            "TITLE": "Da li želite da sačuvate ovaj filter?",
            "CONFIRM": "Sačuvaj filter",
            "LABEL": "Ime",
            "PLACEHOLDER": "Enter the name of the filter",
            "ERROR": "Enter a valid name",
            "SUCCESS_MESSAGE": "Filter saved successfully",
            "ERROR_MESSAGE": "Unable to save filter. Please try again later."
          },
          "DELETE_SEGMENT": {
            "TITLE": "Potvrdite brisanje",
            "DESCRIPTION": "Are you sure you want to delete this filter?",
            "CONFIRM": "Da, obriši",
            "CANCEL": "No, Cancel",
            "SUCCESS_MESSAGE": "Filter deleted successfully",
            "ERROR_MESSAGE": "Unable to delete filter. Please try again later."
          }
        }
      },
      "BLOCK_PUBLIC_DOMAIN_TITLE": "Јавни домен е-поште",
      "BLOCK_PUBLIC_DOMAIN_MESSAGE": "{domain} је јавни домен е-поште који користи много неповезаних пошиљалаца, па се не може блокирати у целини. Да ли желите да блокирате само овај контакт ({email})?",
      "BLOCK_ONLY_THIS_CONTACT": "Блокирај само овај контакт",
      "DIAL": "Pozovi"
    },
    "PAGINATION_FOOTER": {
      "SHOWING": "Showing {startItem} - {endItem} of {totalItems} contacts"
    },
    "FILTER": {
      "NAME": "Ime",
      "EMAIL": "E-pošta",
      "PHONE_NUMBER": "Broj telefona",
      "IDENTIFIER": "Identifikator",
      "COUNTRY": "Država",
      "CITY": "Grad",
      "CREATED_AT": "Napravljena u",
      "LAST_ACTIVITY": "Poslednja aktivnost",
      "REFERER_LINK": "Veza reference",
      "BLOCKED": "Blocked",
      "BLOCKED_TRUE": "Istinito",
      "BLOCKED_FALSE": "Neistinito",
      "BUTTONS": {
        "CLEAR_FILTERS": "Clear filters",
        "UPDATE_SEGMENT": "Update segment",
        "APPLY_FILTERS": "Primenite filtere",
        "ADD_FILTER": "Add filter"
      },
      "TITLE": "Filtriraj kontakte",
      "EDIT_SEGMENT": "Edit segment",
      "SEGMENT": {
        "LABEL": "Segment name",
        "INPUT_PLACEHOLDER": "Enter the name of the segment"
      },
      "ACTIVE_FILTERS": {
        "MORE_FILTERS": "+ {count} more filters",
        "CLEAR_FILTERS": "Clear filters"
      }
    },
    "CARD": {
      "OF": "of",
      "VIEW_DETAILS": "Pogledaj detalje",
      "EDIT_DETAILS_FORM": {
        "TITLE": "Uredi detalje kontakta",
        "FORM": {
          "FIRST_NAME": {
            "PLACEHOLDER": "Enter the first name",
            "ERROR": "Ime je obavezno."
          },
          "LAST_NAME": {
            "PLACEHOLDER": "Enter the last name"
          },
          "EMAIL_ADDRESS": {
            "PLACEHOLDER": "Enter the email address",
            "DUPLICATE": "Ova adresa e-pošte je iskorišćena kod drugog kontakta.",
            "ERROR": "Molim vas unesite ispravnu adresu e-pošte."
          },
          "PHONE_NUMBER": {
            "PLACEHOLDER": "Enter the phone number",
            "DUPLICATE": "Broj telefona je iskorišćen kod drugog kontakta."
          },
          "CITY": {
            "PLACEHOLDER": "Enter the city name"
          },
          "COUNTRY": {
            "PLACEHOLDER": "Select country"
          },
          "BIO": {
            "PLACEHOLDER": "Enter the bio"
          },
          "COMPANY_NAME": {
            "PLACEHOLDER": "Unesite ime kompanije"
          }
        },
        "UPDATE_BUTTON": "Update contact",
        "SUCCESS_MESSAGE": "Contact updated successfully",
        "ERROR_MESSAGE": "Unable to update contact. Please try again later."
      },
      "SOCIAL_MEDIA": {
        "TITLE": "Edit social links",
        "FORM": {
          "FACEBOOK": {
            "PLACEHOLDER": "Add Facebook"
          },
          "GITHUB": {
            "PLACEHOLDER": "Add Github"
          },
          "INSTAGRAM": {
            "PLACEHOLDER": "Add Instagram"
          },
          "WHATSAPP": {
            "PLACEHOLDER": "Dodaj WhatsApp"
          },
          "LINKEDIN": {
            "PLACEHOLDER": "Add LinkedIn"
          },
          "TWITTER": {
            "PLACEHOLDER": "Add Twitter"
          }
        }
      }
    },
    "DETAILS": {
      "CREATED_AT": "Created {date}",
      "LAST_ACTIVITY": "Last active {date}",
      "DELETE_CONTACT_DESCRIPTION": "Permanently delete this contact. This action is irreversible",
      "DELETE_CONTACT": "Obriši kontakt",
      "DELETE_DIALOG": {
        "TITLE": "Potvrdite brisanje",
        "DESCRIPTION": "Are you sure you want to delete this {contactName} contact?",
        "CONFIRM": "Da, obriši",
        "API": {
          "SUCCESS_MESSAGE": "Kontakt je uspešno obrisan",
          "ERROR_MESSAGE": "Nije bilo moguće obrisati kontakt. Molim vas pokušajte ponovo."
        }
      },
      "AVATAR": {
        "UPLOAD": {
          "ERROR_MESSAGE": "Could not upload avatar. Please try again later.",
          "SUCCESS_MESSAGE": "Avatar uploaded successfully"
        },
        "DELETE": {
          "SUCCESS_MESSAGE": "Avatar je uspešno obrisan",
          "ERROR_MESSAGE": "Could not delete avatar. Please try again later."
        }
      }
    },
    "SIDEBAR": {
      "TABS": {
        "ATTRIBUTES": "Attributes",
        "HISTORY": "History",
        "NOTES": "Beleške",
        "MERGE": "Merge",
        "ORDER_HISTORY": "Nedavne porudžbine",
        "RETINO": "Retino"
      },
      "HISTORY": {
        "EMPTY_STATE": "Nema ranijih razgovora povezanih sa ovim kontaktom"
      },
      "ATTRIBUTES": {
        "SEARCH_PLACEHOLDER": "Search for attributes",
        "UNUSED_ATTRIBUTES": "{count} Used attribute | {count} Unused attributes",
        "EMPTY_STATE": "There are no contact custom attributes available in this account. You can create a custom attribute in settings.",
        "YES": "Da",
        "NO": "Ne",
        "TRIGGER": {
          "SELECT": "Izaberite vrednost",
          "INPUT": "Enter value"
        },
        "VALIDATIONS": {
          "INVALID_NUMBER": "Invalid number",
          "REQUIRED": "Ispravna vrednost je obavezna",
          "INVALID_INPUT": "Invalid input",
          "INVALID_URL": "Neispravna adresa",
          "INVALID_DATE": "Invalid date"
        },
        "NO_ATTRIBUTES": "Nijedan atribut nije pronađen",
        "API": {
          "SUCCESS_MESSAGE": "Atribut je uspešno izmenjen",
          "DELETE_SUCCESS_MESSAGE": "Atribut je uspešno obrisan",
          "UPDATE_ERROR": "Nije bilo moguće izmeniti atribut. Molim vas pokušajte ponovo",
          "DELETE_ERROR": "Nije bilo moguće obrisati atribut. Molim vas pokušajte ponovo"
        }
      },
      "MERGE": {
        "TITLE": "Spoji kontakt",
        "DESCRIPTION": "Combine two profiles into one, including all attributes and conversations. In case of conflict, the primary contact’s attributes will take precedence.",
        "PRIMARY": "Glavni kontakt",
        "PRIMARY_HELP_LABEL": "To be saved",
        "PRIMARY_REQUIRED_ERROR": "Please select a contact to merge with before proceeding",
        "PARENT": "To be merged",
        "PARENT_HELP_LABEL": "Da bude obrisan",
        "EMPTY_STATE": "No contacts found",
        "PLACEHOLDER": "Search for primary contact",
        "SEARCH_PLACEHOLDER": "Traži kontakta",
        "SEARCH_ERROR_MESSAGE": "Could not search for contacts. Please try again later.",
        "SUCCESS_MESSAGE": "Kontakt je uspešno spojen",
        "ERROR_MESSAGE": "Nije bilo moguće spojiti kontakte, pokušajte ponovo!",
        "IS_SEARCHING": "Searching...",
        "BUTTONS": {
          "CANCEL": "Otkaži",
          "CONFIRM": "Spoji kontakt"
        }
      },
      "NOTES": {
        "PLACEHOLDER": "Dodaj belešku",
        "WROTE": "wrote",
        "YOU": "You",
        "SAVE": "Save note",
        "EMPTY_STATE": "There are no notes associated to this contact. You can add a note by typing in the box above."
      }
    },
    "EMPTY_STATE": {
      "TITLE": "No contacts found in this account",
      "SUBTITLE": "Start adding new contacts by clicking on the button below",
      "BUTTON_LABEL": "Add contact",
      "SEARCH_EMPTY_STATE_TITLE": "Nisu pronađeni kontakti 🔍",
      "LIST_EMPTY_STATE_TITLE": "No contacts available in this view 📋"
    }
  },
  "COMPOSE_NEW_CONVERSATION": {
    "TITLE": "Novi razgovor",
    "CONTACT_SEARCH": {
      "ERROR_MESSAGE": "We couldn’t complete the search. Please try again."
    },
    "FORM": {
      "GO_TO_CONVERSATION": "Pregled",
      "SUCCESS_MESSAGE": "The message was sent successfully!",
      "ERROR_MESSAGE": "An error occurred while creating the conversation. Please try again later.",
      "NO_INBOX_ALERT": "There are no available inboxes to start a conversation with this contact.",
      "CONTACT_SELECTOR": {
        "LABEL": "Za:",
        "TAG_INPUT_PLACEHOLDER": "Search for a contact with name, email or phone number",
        "CONTACT_CREATING": "Creating contact..."
      },
      "INBOX_SELECTOR": {
        "LABEL": "Via:",
        "BUTTON": "Show inboxes"
      },
      "EMAIL_OPTIONS": {
        "SUBJECT_LABEL": "Naslov :",
        "SUBJECT_PLACEHOLDER": "Enter your email subject here",
        "CC_LABEL": "Cc:",
        "CC_PLACEHOLDER": "Search for a contact with their email address",
        "BCC_LABEL": "Bcc:",
        "BCC_PLACEHOLDER": "Search for a contact with their email address",
        "BCC_BUTTON": "Bcc"
      },
      "MESSAGE_EDITOR": {
        "PLACEHOLDER": "Unesite Vašu poruku ovde..."
      },
      "WHATSAPP_OPTIONS": {
        "LABEL": "Select template",
        "SEARCH_PLACEHOLDER": "Search templates",
        "EMPTY_STATE": "No templates found",
        "TEMPLATE_PARSER": {
          "TEMPLATE_NAME": "WhatsApp template: {templateName}",
          "VARIABLES": "Promenljive",
          "BACK": "Povratak",
          "SEND_MESSAGE": "Pošalji poruku"
        }
      },
      "ACTION_BUTTONS": {
        "DISCARD": "Discard",
        "SEND": "Send ({keyCode})",
        "MARK_RESOLVED": "Označi novi razgovor kao rešen nakon slanja",
        "SAVE_DRAFT": "Sačuvaj nacrt",
        "CREATE_AS_INTERNAL": "Napravi kao razgovor sa beleškom",
        "SEND_AND_RESOLVE_ORIGINAL": "Pošalji i reši originalni razgovor ({keyCode})"
      },
      "DISCARD": "Odbaci nacrt",
      "DISCARD_MODAL": {
        "TITLE": "Odbaci nacrt",
        "DESCRIPTION": "Da li ste sigurni da želite da odbacite ovaj nacrt?",
        "CONFIRM": "Da, odbaci",
        "CANCEL": "Ne, zadrži"
      }
    }
  }
}
